import React from 'react';
import doc from '@/assets/filetypes/filetype-doc.png';
import html from '@/assets/filetypes/filetype-html.png';
import jpg from '@/assets/filetypes/filetype-jpg.png';
import mov from '@/assets/filetypes/filetype-mov.png';
import mp3 from '@/assets/filetypes/filetype-mp3.png';
import pdf from '@/assets/filetypes/filetype-pdf.png';
import rar from '@/assets/filetypes/filetype-rar.png';
import zip from '@/assets/filetypes/filetype-zip.png';
import xls from '@/assets/filetypes/filetype-xls.png';
import csv from '@/assets/filetypes/filetype-csv.png';

const FileType = ({ type, height = 54, ...props }) => {
  let fileType = type.replace('.', '').toLowerCase();
  let fileTypeImg = doc;
  if (type.includes('openxmlformats-officedocument.spreadsheetml.sheet')) fileType = 'xls';

  switch (fileType) {
    case 'doc':
    case 'txt':
    case 'text/plain':
    case 'subtitle':
      fileTypeImg = doc;
      break;
    case 'html':
    case 'xml':
    case 'json':
    case 'application/json':
      fileTypeImg = html;
      break;
    case 'jpg':
    case 'png':
    case 'svg':
    case 'image':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
      fileTypeImg = jpg;
      break;
    case 'mp3':
    case 'wav':
    case 'audio':
    case 'audio/mp4':
    case 'audio/mp3':
    case 'audio/wav':
      fileTypeImg = mp3;
      break;
    case 'mov':
    case 'avi':
    case 'mp4':
    case 'video/mov':
    case 'video/avi':
    case 'video/mp4':
    case 'video/wmv':
    case 'master':
      fileTypeImg = mov;
      break;
    case 'pdf':
    case 'application/pdf':
      fileTypeImg = pdf;
      break;
    case 'csv':
    case 'text/csv':
      fileTypeImg = csv;
      break;
    case 'rar':
      fileTypeImg = rar;
      break;
    case 'zip':
      fileTypeImg = zip;
      break;
    case 'xls':
    case 'xlsx':
      fileTypeImg = xls;
      break;
  }

  return <img src={fileTypeImg} alt={type} height={height} {...props} />;
};

export default FileType;
